import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
function SelfProject(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
           <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('SelfProject')}>Previous</Link></span>
            </div>
           <h5 class="card-header">Anyberlink IT Solutions, India	
                              <br/>Feb 2013 – Jul 2014
                              <br/>Net Developer
           </h5>    					       
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
           -Involved in all the phases such as Analysis, Design, Coding, Testing (Unit & Regression) and Deployment for the Desktop as well as the Web Versions.
          <br />-Worked on User controls and consumed in different forms.
          <br />-Created various MIS Reports using Data Grid Control and displayed the data.
          <br />-Worked on Web Services and Consumed in Client application.
          <br />-Created Web Pages for the application and used classes for the code reusability.
          <br />-This is a web-based application designed using.NET Framework, ASP.NET MVC5.
          <br />-ADO.NET Entity Framework is used in accordance with ASP.NET MVC to import databases from MS SQL Server 2005.
          <br />-Various filters were used to implement authorization, error handling, and cache management.
          <br />-Created responsive web pages using Razor views, ASP.NET, HTML5 and CSS3.
          <br />-Stored procedures are reused throughout the application to manage the database.
          <br />-Expertise in creating stored procedures, triggers and views in SQL server.
          <br />-Used code first approach with Entity Framework to interact with the database.
          <br />-Language Integrated Query (LINQ) is used with C# to write queries.
          <br />-Roles are created based on the designation to restrict access to information.
          <br />-TFS,SVN was the tool used for version control.
          
            <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Microsoft Visual Studio 2012, ASP.NET, C#, JSON, Agile and Scrum,GIT, AJAX, CSHTML, CSS,  SQL Server 2017, Windows Server 2010 ,Angular Cli,Angular,Angular Material
           </div>            
         </div>
       </div>
       
)
}
export default SelfProject